import creditCardType from 'credit-card-type';
export var prettyCardNumber = function prettyCardNumber(cardNumber, cardType) {
  var card = creditCardType.getTypeInfo(cardType);

  if (card) {
    var offsets = [].concat(0, card.gaps, cardNumber.length);
    var components = [];

    for (var i = 0; offsets[i] < cardNumber.length; i++) {
      var start = offsets[i];
      var end = Math.min(offsets[i + 1], cardNumber.length);
      components.push(cardNumber.substring(start, end));
    }

    return components.join(' ');
  }

  return cardNumber;
};
export var generateCardPlaceholder = function generateCardPlaceholder(length) {
  return Array.from(Array(length)).map(function () {
    return '#';
  }).join('');
};
export var prependEmptySpace = function prependEmptySpace(last4, cardType) {
  var card = creditCardType.getTypeInfo(cardType);
  var totalLength = card.lengths[0];
  return new Array(totalLength - 4).fill('X').join('') + last4;
};